import { render, staticRenderFns } from "./classifyTabs.vue?vue&type=template&id=534d4fc6&scoped=true"
import script from "./classifyTabs.vue?vue&type=script&lang=js"
export * from "./classifyTabs.vue?vue&type=script&lang=js"
import style0 from "./classifyTabs.vue?vue&type=style&index=0&id=534d4fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d4fc6",
  null
  
)

export default component.exports